import { hardSkillsData } from "./hardSkillsData";
import styles from "./style.module.scss";
import HardSkillCard from "./HardSkillCard";

export default function HardSkills() {
   return (
      <section id="#curriculo">
         <div className="container">
            <div>
               <h2 className="title one blue">
                  E COMO SERÁ O SEU PERCURSO DE APRENDIZADO?
               </h2>
               <ol className={styles.hardSkillList}>
                  {hardSkillsData.map((hardSkill) => (
                     <HardSkillCard key={hardSkill.id} hardSkill={hardSkill} />
                  ))}
               </ol>
            </div>
         </div>
      </section>
   );
}
